import BaseModelAPI from '../BaseModelAPI';

export default class ReportStockCardList extends BaseModelAPI {

	static entity = 'newreport2001list'
	static entityName = 'reportstockcard';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
